import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/sichuan_airport',
    name: 'sichuanAir',
    component: ()=>import("@/views/SichuanAirportView.vue")
  },
  {
    path: '/login/:type',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/LoginView.vue')
  },
  {
    path: '/pay/:type',
    name: 'pay',
    component: ()=>import('@/views/PayView.vue'),
    meta:{
      title: '余额兑换'
    }
  },
  {
    path: '/code',
    name: 'code',
    component: ()=>import('@/views/PayCodeView.vue'),
    meta:{
      title: '结账码'
    }
  },
  {
    path: '/xm_code',
    name: 'xm_code',
    component: ()=>import('@/views/XiamenAirSuccess.vue'),
    meta:{
      title: '兑换成功'
    }
  },
  {
    path: '/successful/:order',
    name: 'success',
    component: ()=>import('@/views/PaySuccessView.vue'),
    meta:{
      title: '结账完成'
    }
  },
  {
    path: '/order',
    name: 'order',
    component: ()=>import('@/views/OrderView.vue'),
    meta:{
      title: '兑换记录'
    }
  },
  {
    path: '/store',
    name: 'store',
    component: ()=>import('@/views/StoreListView.vue'),
    meta:{
      title: '门店列表'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to,from,next)=>{
  document.title = to.meta.title ? to.meta.title : '见福积分兑换';
  next();
})
export default router
